export default {
  LEASE_AUCTION: "companies/:company_id/auctions/lease-auction/",
	AUCTIONS: 'companies/:company_id/auctions/'
};
